import { useFormik } from "formik";
import React, { useState } from "react";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { resetPassword } from "../../redux/services/authSlice";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const getEmail = queryParams.get("email");
  const [toggle1, setToggle1] = useState(false);
  const [toggle2, setToggle2] = useState(false);
  const [getResetLoading, setGetResetLoading] = useState(false);

  const initialValues = {
    newPassword: "",
    confirmPassword: "",
  };
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .matches(
        passwordRegex,
        "Password must include uppercase, lowercase, number, and special character."
      )
      .min(8, "Password must be at least 8 characters long")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });
  const onSubmit = async (values) => {
    let payload = {
      uniqueId: getEmail,
      password: values.newPassword,
      userType: "admin",
    };
    setGetResetLoading(true);
    try {
      const response = await dispatch(resetPassword(payload));
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setGetResetLoading(false);
        navigate("/");
        resetForm();
      }
    } catch (error) {
      setGetResetLoading(false);
    } finally {
      setGetResetLoading(false);
    }
  };
  const {
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans text-foreground">
      <div className="w-full max-w-lg overflow-hidden rounded-xl border border-border bg-card shadow-theme">
        <div className="h-1.5 card-gradient-strip" />
        <div className="p-5 sm:p-8">
        <h2 className="font-heading text-xl sm:text-2xl font-bold text-primary text-center tracking-tight mb-1">
          Reset Password
        </h2>
        <p className="text-center text-sm text-muted-foreground mb-5 sm:mb-6">
          Enter your new password to reset your account.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="my-5 sm:my-6">
            <label className="bef-label">
              New Password
            </label>
            <div className="relative">
              <input
                type={toggle1 ? "text" : "password"}
                name="newPassword"
                value={values.newPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter new password"
                className="bef-input !pr-12"
              />
              <button
                type="button"
                onClick={() => setToggle1(!toggle1)}
                className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-primary rounded-e-xl focus:outline-none hover:text-accent transition-colors"
              >
                {toggle1 ? (
                  <VscEyeClosed title="Show Password" color="#5B6577" />
                ) : (
                  <VscEye title="Hide Password" color="#5B6577" />
                )}
              </button>
            </div>
            {errors.newPassword && touched.newPassword && (
              <p className="mt-1 px-2 text-red-600 text-sm">
                {errors.newPassword}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label className="bef-label">
              Confirm New Password
            </label>
            <div className="relative">
              <input
                type={toggle2 ? "text" : "password"}
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Confirm new password"
                autoComplete="off"
                className="bef-input !pr-12"
              />
              <button
                type="button"
                onClick={() => setToggle2(!toggle2)}
                className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-primary rounded-e-xl focus:outline-none hover:text-accent transition-colors"
              >
                {toggle2 ? (
                  <VscEyeClosed title="Show Password" color="#5B6577" />
                ) : (
                  <VscEye title="Hide Password" color="#5B6577" />
                )}
              </button>
            </div>
            {errors.confirmPassword && touched.confirmPassword && (
              <p className="mt-1 px-2 text-red-600 text-sm">
                {errors.confirmPassword}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={getResetLoading}
            className={`bef-btn-primary w-full mt-6 sm:mt-7 transition-all duration-300 ${
              getResetLoading
                ? "!bg-primary !border-primary !text-white opacity-90 cursor-wait pointer-events-none"
                : ""
            }`}
          >
            {getResetLoading ? (
              <div className="loader"></div>
            ) : (
              "Reset Password"
            )}
          </button>
        </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
